import React from 'react';
import { Leaf, Settings, Zap, RefreshCw } from 'lucide-react';

export interface ModeStyle03Props {
  value?: string;
  options: string[];
  disabled?: boolean;
  loading?: boolean;
  onChange: (value: string) => void;
  label?: string;
  labels?: Record<string, string>;
  icons?: Record<string, React.ElementType>;
}

// Default mode icons
const DEFAULT_ICONS: Record<string, React.ElementType> = {
  '1': Leaf,
  '3': Settings,
  '5': Zap,
  '8': RefreshCw,
  'eco': Leaf,
  'standard': Settings,
  'power': Zap,
  'continuous': RefreshCw,
  'auto': Settings
};

// Default mode labels
const DEFAULT_LABELS: Record<string, string> = {
  '1': '節能',
  '3': '標準',
  '5': '強力',
  '8': '連續',
  'eco': '節能',
  'standard': '標準',
  'power': '強力',
  'continuous': '連續',
  'auto': '自動'
};

/**
 * Mode Style 03 - Icon Circle
 * Circular icon buttons with labels below
 */
export const Style03_IconCircle: React.FC<ModeStyle03Props> = ({
  value,
  options,
  disabled = false,
  loading = false,
  onChange,
  label = '運轉模式',
  labels = DEFAULT_LABELS,
  icons = DEFAULT_ICONS
}) => {
  const getModeConfig = (mode: string) => {
    return {
      icon: icons[mode] || Settings,
      label: labels[mode] || mode
    };
  };

  return (
    <div className="space-y-3">
      <span className="text-sm font-medium text-slate-300">{label}</span>
      <div className="flex justify-between gap-2">
        {options.map((mode) => {
          const isSelected = value === mode;
          const config = getModeConfig(mode);
          const Icon = config.icon;
          
          return (
            <button
              key={mode}
              onClick={() => onChange(mode)}
              disabled={disabled || loading}
              className={`flex-1 flex flex-col items-center gap-2 py-3 rounded-2xl transition-all ${
                isSelected
                  ? 'bg-blue-500 text-white shadow-lg shadow-blue-500/30'
                  : 'bg-slate-800/50 text-slate-400 hover:bg-slate-700/50'
              } ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`}
            >
              <div className={`w-10 h-10 rounded-full flex items-center justify-center ${
                isSelected ? 'bg-blue-400/30' : 'bg-slate-700/50'
              }`}>
                <Icon className="w-5 h-5" />
              </div>
              <span className="text-xs font-medium">
                {loading && isSelected ? '...' : config.label}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default Style03_IconCircle;
